import { connect } from 'react-redux';
import UserInfoPage from './UserInfoPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { fetchCurrentUserInfo } from '../../actions/basicAction';
export const mapStateToProps = (state: AppState) => {
    return {
        loadingText: 'Processing . . .'
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {        
        onComponentDidMount:  () => {                       
            dispatch(fetchCurrentUserInfo()); 
        }
    };
};

const UserInfoPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(UserInfoPage);

export default UserInfoPageContainer;



// WEBPACK FOOTER //
// ./src/components/userinfo/UserInfoPageContainer.tsx